import OnvoBase from "../base.js";
import { Log, LogType } from "../types/index.js";

// Logs endpoints
export class OnvoLogs extends OnvoBase {
    /**
     * Lists all logs for a given dashboard.
     *
     * @returns {Promise<Log[]>} A promise that resolves to an array of logs.
     */
    list(): Promise<Log[]> {
        return this._fetchBase(
            "/api/logs"
        ) as Promise<Log[]>;
    }

    /**
     * Creates a new log.
     *
     * @param {Object} payload - The payload for the log creation.
     * @param {string} payload.type - The type of log to create.
     * @param {string} payload.dashboard - The ID of the dashboard to create the log for.
     * @param {string} payload.widget - The ID of the widget to create the log for.
     * @returns {Promise<Log>} A promise that resolves to the created log.
     */
    create(payload: {
        type: LogType;
        dashboard: string;
        widget?: string;
    }): Promise<Log> {
        return this._fetchBase("/api/logs", "POST", payload) as Promise<Log>;
    }

}
